(function () {
	"use strict";

	if (typeof document === "undefined") return;

	var COOKIE_NAME =
		window.bds_theme.features.cookie_consent.cookie_name ||
		"bds_cookie_consent";
	var COOKIE_EXPIRES =
		window.bds_theme.features.cookie_consent.expires || 365;

	/**
	 * Set cookie.
	 */
	function setCookie(name, value, days) {
		var expires = "";

		if (typeof days === "number") {
			var date = new Date();

			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = "; expires=" + date.toUTCString();
		}

		document.cookie =
			name +
			"=" +
			encodeURIComponent(value) +
			expires +
			"; path=/; SameSite=Lax";
	}

	/**
	 * Get cookie.
	 */
	function getCookie(name) {
		var match = document.cookie.match(
			new RegExp("(^| )" + name + "=([^;]+)"),
		);

		return match ? decodeURIComponent(match[2]) : null;
	}

	/**
	 * Parse cookie content.
	 */
	function parseConsent(raw) {
		try {
			return raw ? JSON.parse(raw) : null;
		} catch (e) {
			return null;
		}
	}

	/**
	 * Save consent.
	 */
	function saveConsent(consentObj) {
		setCookie(COOKIE_NAME, JSON.stringify(consentObj), COOKIE_EXPIRES);
	}

	/**
	 * Load analytics.
	 */
	function loadAnalytics() {
		try {
			// Google Analytics (gtag)

			var uaCode =
				window.bds_theme.features.cookie_consent.google_analytics
					.ua_code || "";

			if (uaCode) {
				var gaScript = document.createElement("script");

				gaScript.async = true;
				gaScript.src =
					"https://www.googletagmanager.com/gtag/js?id=" + uaCode;
				document.head.appendChild(gaScript);

				gaScript.onload = function () {
					window.dataLayer = window.dataLayer || [];
					function gtag() {
						dataLayer.push(arguments);
					}
					window.gtag = gtag;
					gtag("js", new Date());
					gtag("config", uaCode);
				};
			}

			// Google Tag Manager

			var gtmId =
				window.bds_theme.features.cookie_consent.google_analytics
					.gtm_id || "";

			if (gtmId) {
				var gtmScript = document.createElement("script");

				gtmScript.innerHTML =
					"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" +
					gtmId +
					"');";
				document.head.appendChild(gtmScript);

				// Optionally add noscript iframe for GTM (will only add if consent allows)

				var gtmNoscript = document.createElement("noscript");

				gtmNoscript.innerHTML =
					'<iframe src="https://www.googletagmanager.com/ns.html?id=' +
					gtmId +
					'" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
				document.body.appendChild(gtmNoscript);
			}
		} catch (e) {
			console.warn("Error loading analytics libs", e);
		}
	}

	document.addEventListener("DOMContentLoaded", function () {
		var banner = document.querySelector(".bds-cookie-consent");
		var consentRaw = getCookie(COOKIE_NAME);
		var consent = parseConsent(consentRaw);

		// If consent exists, don't show banner and apply consent immediately.

		if (consent) {
			if (banner) banner.style.display = "none";

			if (consent.analytics) {
				loadAnalytics();
			}
		} else {
			// Show banner if consent cookie is not present.

			if (banner) {
				banner.style.display = "block";

				setTimeout(function () {
					banner.classList.add("active");
				}, 10);
			}
		}

		var btnDismiss = document.querySelector(".bds-cookie-consent__dismiss");
		var btnReject = document.querySelector(".bds-cookie-consent__reject");

		if (btnDismiss) {
			btnDismiss.addEventListener("click", function () {
				var allConsent = { essential: true, analytics: true };

				saveConsent(allConsent);

				if (banner) {
					banner.classList.remove("active");

					banner.addEventListener(
						"transitionend",
						function handler(e) {
							if (e.propertyName === "opacity") {
								banner.removeEventListener(
									"transitionend",
									handler,
								);

								if (banner.parentNode) {
									banner.parentNode.removeChild(banner);
								}
							}
						},
					);
				}

				if (allConsent.analytics) {
					loadAnalytics();
				}
			});
		}

		if (btnReject) {
			btnReject.addEventListener("click", function () {
				var rejectConsent = { essential: true, analytics: false };

				saveConsent(rejectConsent);

				if (banner) {
					banner.classList.remove("active");

					banner.addEventListener(
						"transitionend",
						function handler(e) {
							if (e.propertyName === "opacity") {
								banner.removeEventListener(
									"transitionend",
									handler,
								);

								if (banner.parentNode) {
									banner.parentNode.removeChild(banner);
								}
							}
						},
					);
				}
			});
		}
	});
})();
